<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <v-row no-gutters class="mx-3">
      <!-- select of filters available -->
      <v-col cols="5">
        <v-autocomplete
          v-model="facetNewValue.facet"
          item-color="info"
          menu-props="light"
          :rules="[v => !!v || 'Required']"
          :items="alteredFacetsList"
          label="Nom"
          item-text="label"
          item-value="value"
          autocomplete="off"
          clearable
          color="blue"
          @change="changeFacet"
        />
      </v-col>
      <v-col cols="1"> <p class="text-center py-4">est</p></v-col>

      <!-- field of custom filter -->
      <v-col cols="5">
        <FacetValuesSelection
          v-model="facetNewValue.values"
          :facet="facetNewValue.facet"
          :allow-copy="!disableCopyPaste"
          :disabled="!facetNewValue.facet"
          :search-by-query="searchByQuery"
          :rules="[v => !!v && v.length > 0 || 'Required']"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import FacetValuesSelection from '../ActionFormFields/common/FacetValuesSelection.vue';

const { useFacetSettings } = require('@/utils/merch');

const props = defineProps({ value: { type: Object, default: null }, unavailableFacets: { type: Array, default: () => [] } });
const emit = defineEmits('update:filter');

const store = useStore();

const facetNewValue = ref(props.value);

const { disableCopyPaste, searchByQuery, facetsList, facetSettings } = useFacetSettings(facetNewValue, store.getters.ruleFacets);

const alteredFacetsList = computed(() => facetsList.value.map(facet => {
  const newFacet = { value: facet.value, label: facet.label };

  if (props.unavailableFacets.includes(facet.value)) {
    newFacet.disabled = true;
  }

  return newFacet;
}));

const changeFacet = val => {
  facetNewValue.value.values = [];
};

const tempFix = () => {
  if (facetNewValue.value.values && !Array.isArray(facetNewValue.value.values)) {
    facetNewValue.value.values = [{ value: facetNewValue.value.values }];
  }
};

tempFix();

// Watch for changes in facetNewValue and emit update to parent
watch(() => facetNewValue.value, val => {
  emit('update:filter', val);
}, { deep: true });

</script>

<style scoped>
/* Add your component-specific styles here */
</style>
